import React from "react";
import ReactMarkdown from "react-markdown";
import { Icon } from "@zapier/design-system";
import styles from "./Composer.module.css";

interface ReasoningPartProps {
  reasoning: string;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  isCompleted: boolean;
}

export const ReasoningPart: React.FC<ReasoningPartProps> = ({
  reasoning,
  isCollapsed,
  onToggleCollapse,
  isCompleted,
}) => {
  return (
    <div className={styles.reasoningContainer}>
      <button
        onClick={onToggleCollapse}
        aria-expanded={!isCollapsed}
        className={styles.reasoningToggleButton}
        type="button"
      >
        <Icon
          name={isCollapsed ? "arrowSmallDown" : "arrowSmallUp"}
          size={14}
        />
        <span className={styles.reasoningToggleButtonText}>
          {isCollapsed ? "Show context" : "Hide context"}
        </span>
        {!isCompleted && (
          <span className={styles.reasoningStreamIndicator}>
            <span className={styles.reasoningPulsingDot}></span>
          </span>
        )}
      </button>
      <div
        className={`${styles.reasoningContent} ${isCollapsed ? styles.reasoningCollapsed : ""}`}
      >
        {!isCollapsed && <ReactMarkdown>{reasoning}</ReactMarkdown>}
      </div>
    </div>
  );
};
